import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DateInput } from "@/components/DateInput";
import { MONTHS } from "@/components/DateFilter";
import { STATUS, EMPTY_FILTER } from "@/lib/seat";

const Pick = ({ value, onChange, testid, items, all, className = "w-full sm:w-44" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`h-10 bg-white ${className}`} data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      {all && <SelectItem value="all">{all}</SelectItem>}
      {items.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const SeatFilters = ({ f, set, groups, cities, years }) => (
  <div className="space-y-4 rounded-lg border border-slate-200 bg-white p-4 sm:p-5 fade-up" style={{ animationDelay: "60ms" }}>
    <div className="relative">
      <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Cari nama produk, destinasi, maskapai..." className="h-12 pl-11 text-base bg-slate-50 border-slate-200" data-testid="seat-search-input" />
    </div>
    <div className="grid grid-cols-1 gap-2 sm:flex sm:flex-wrap">
      <Pick value={f.group} onChange={(v) => set({ group: v })} testid="seat-filter-group" all="Semua maskapai/charter" items={groups.map((g) => [g, g])} className="w-full sm:w-60" />
      <Pick value={f.city} onChange={(v) => set({ city: v })} testid="seat-filter-city" all="Semua kota" items={cities.map((c) => [c, c])} />
      <Pick value={f.status} onChange={(v) => set({ status: v })} testid="seat-filter-status" all="Semua status" items={Object.entries(STATUS).map(([k, s]) => [k, `${s.short} - ${s.label}`])} />
      <Pick value={f.sort} onChange={(v) => set({ sort: v })} testid="seat-sort" items={[["nearest", "Keberangkatan terdekat"], ["name", "Nama A-Z"], ["promo", "Sedang promo dulu"]]} className="w-full sm:w-56" />
    </div>
    <div className="flex flex-col gap-3 border-t border-slate-100 pt-4 lg:flex-row lg:items-center lg:flex-wrap">
      <span className="overline-label">Keberangkatan</span>
      <div className="flex items-center gap-2">
        <DateInput value={f.from} onChange={(v) => set({ from: v })} className="h-10 w-36 text-sm" data-testid="seat-filter-from" />
        <span className="text-sm text-slate-400">s/d</span>
        <DateInput value={f.to} onChange={(v) => set({ to: v })} className="h-10 w-36 text-sm" data-testid="seat-filter-to" />
      </div>
      <div className="flex gap-2">
        <Pick value={f.month} onChange={(v) => set({ month: v })} testid="seat-filter-month" all="Semua bulan" items={MONTHS.map((m, i) => [String(i + 1), m])} className="w-40" />
        <Pick value={f.year} onChange={(v) => set({ year: v })} testid="seat-filter-year" all="Semua tahun" items={years.map((y) => [y, y])} className="w-36" />
      </div>
      <button onClick={() => set(EMPTY_FILTER)} className="text-sm text-brand hover:underline lg:ml-auto" data-testid="seat-filter-reset">Reset filter</button>
    </div>
  </div>
);
